export default class ForceDisconnectingPopup {
    #browserTabId
    #onForceCallBack;
    #cancelCallback;
    #onErrorCallBack;

    #id = "disconnecting-popup";

    constructor(browserTabId, onForceCallBack, cancelCallback, onErrorCallBack) {
        this.#browserTabId = browserTabId;
        this.#onForceCallBack = onForceCallBack;
        this.#cancelCallback = cancelCallback;
        this.#onErrorCallBack = onErrorCallBack;
    };

    async open() {

        let response;
        try
        {
            response = await fetch(`${BINamespace.getPathUrl()}/Proxyless/GetForceDisconnectingPopup/${this.#browserTabId}`);
        } catch(error) {
            this.#onError(error);
            return;
        }

        if(!response.ok)
        {
            this.#onError(response.statusText);
            return;
        }

        const div = document.createElement("div");
        div.id = this.#id;
        div.innerHTML = await response.text();

        document.body.appendChild(div);

        // We do not have the popupmanager in the BINamespace
        // yet, so we must instantiate the window manually.
        const settings = {
            title: BINamespace.loginLabels.STR_WARNING,
            maxWidth: "35rem",
            width: "auto",
            maxHeight: "14rem",
            height: "100%",
            resizable: false,
            scrollable: false,
            modal: true
        };

        const window = $(div).kendoWindow(settings).data("kendoWindow"); 
        
        document.getElementById("force-disconnecting-btn")?.addEventListener("click", async () => await this.#onForceDisconnect());       
        document.getElementById("cancel-btn")?.addEventListener("click", async () => await this.#onCancel());

        $(div).parent().find("a[aria-label='Close']").remove();
       
        window?.center().open();
    }

    async #onForceDisconnect() {
        let response;
        try
        {
            response = await fetch(`${BINamespace.getPathUrl()}/Account/PostConnectEviction/${this.#browserTabId}`);
        } catch(error) {
            this.#onError(error, true);         
            return;
        }

        if(!response.ok)
        {
            this.#onError(response.statusText, true);
            return;
        }

        const body = await response.json();

        if (body.Errors) {
            const err = body.Errors.error?.errors?.[0];
            const advErr = body.Errors.advancedError?.errors?.[0]
            this.#onError(`${BINamespace.HTMLDecode(err)} - ${BINamespace.HTMLDecode(advErr)}`, true);
            return;
        }

        if (body.evicted)
        {
            console.log("Evicted:", body.evicted);
        }

        if (typeof this.#onForceCallBack === "function") {
            this.#onForceCallBack();
        } 

        this.#close();
    }

    async #onCancel() {

        let response;
        try
        {
            response = await fetch(`${BINamespace.getPathUrl()}/Logout/Logout/${this.#browserTabId}?removeAllCredentials=true`, 
            {
                method: 'POST'
            });
        } catch(error) {
            this.#onError(error);         
            return;
        }

        if(!response.ok)
        {
            this.#onError(response.statusText);
            return;
        }

        if (typeof this.#cancelCallback === "function") {
            this.#cancelCallback();
        } 

        this.#close();
    }

    #onError(error, close) {
        if (typeof this.#onErrorCallBack === "function") {
            this.#onErrorCallBack("Unable to continue eviction", error);
        } 

        if(close)
        {
            this.#close();
        }
    }

    #close() {
        const window = $(`#${this.#id}`).data("kendoWindow"); 

        window?.close();
        window?.destroy();       
    }
}